// extracted by mini-css-extract-plugin
export default {"root":"landingWelcome_root__7FsNs","left_bottom":"landingWelcome_left_bottom__HGVy7"};